import { Breadcrumbs, Typography } from '@mui/material';
import React from 'react'
import {Link} from "react-router-dom"
function handleClick(event) {
    event.preventDefault();
    console.info('You clicked a breadcrumb.');
  }
const BreadcrumbsB = ({currPageName}) => {
    return (
        <div role="presentation" onClick={handleClick}>
        <Breadcrumbs aria-label="breadcrumb">
          {/* <Link underline="hover" color="inherit" href="/">
            MUI
          </Link> */}
          <Link
            underline="hover"
            color="inherit"
            href="/getting-started/installation/"
          >
            Home
          </Link>
          <Typography color="text.primary">{currPageName}</Typography>
        </Breadcrumbs>
      </div>
    )
}

export default BreadcrumbsB
